import { css } from '@inter-ikea-kompis/web-component';

export default class LawLabelStyle {
	public static getStyle(): string {
		return css`
			:host {
				display: flex;
				flex-direction: column;
			}
		`;
	}
}
